<div class="duna-login-component primary-container">
  <!-- Add login form here with material design, username, password, login button, and forgot password link -->
  <form (ngSubmit)="onSubmit()" class="login-form">
    <mat-form-field appearance="fill">
      <mat-label>Username</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="username"
        name="username"
        required
        autocomplete="username"
      />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Kodeord</mat-label>
      <input
        matInput
        type="password"
        [(ngModel)]="password"
        name="password"
        required
        autocomplete="current-password"
      />
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit">Log ind</button>

    <a mat-button color="accent" routerLink="/forgot-password"
      >Glemt adgangskode?</a
    >
  </form>
</div>

@if (isLoading$ | async) {
<app-loading-spinner></app-loading-spinner>
}
